import { decodeHtml } from "helpers/emailHelper";
import { invalidateEmailTemplateTableQuery } from "hooks/useEmailTemplateTable";
import EmailTemplateService from "services/EmailTemplate";

export const EMAIL_TEMPLATES_PATH = "/settings/email_templates";

export const emailTemplateQueryKey = id => ["email-template", String(id)];

// The repository HTML-escapes the body on save, so every reader decodes it.
export const decodeTemplateHtml = template =>
  decodeHtml(unescape(template?.html || ""));

/**
 * The stored `info`, read fresh for a save that sends it back whole. Every save
 * queues an image-processing task that rewrites image URLs in `info.design`
 * after the response returns, so the cached copy can predate that rewrite.
 */
export const fetchLatestInfo = async id => {
  const latest = await EmailTemplateService.getEmailTemplate(id);
  return latest.info ?? {};
};

/**
 * Seeds the editor cache with the template a save returned, so the next tab
 * mounts on it without a refetch, and refreshes the other views that read
 * the template: the list and the footer and signature preview frames.
 */
export const storeSavedTemplate = async (queryClient, saved) => {
  queryClient.setQueryData(emailTemplateQueryKey(saved.id), saved);
  await Promise.all([
    invalidateEmailTemplateTableQuery(),
    queryClient.invalidateQueries({
      queryKey: ["email-template-html", saved.id],
    }),
  ]);
};
